import { Typography } from 'antd';
import styled from 'styled-components';

export const TextCustom = styled(Typography.Text)`
  color: #65646499;
  font-family: 'inter-regular', sans-serif;
  font-weight: 700;
  font-size: 14px;
`;
